import { Button } from '@findigs/ui-kit/src/components/button';
import { Links } from '@remix-run/react';
import type { RouteError } from '~/types';

export type RouteErrorViewProps = {
  error: RouteError;
};

const ErrorMessage = ({ status }: { status: number }) => {
  const classes = 'mb-12 md:text-b-lg-regular';

  if (status == 500) {
    return (
      <p className={classes}>
        The server encountered an error and could not complete your request. If
        you need immediate assistance please contact{' '}
        <a href="mailto:pm-support@findigs.com">pm-support@findigs.com</a>
      </p>
    );
  }

  return (
    <p className={classes}>
      Something went wrong, please reach out to{' '}
      <a href="mailto:pm-support@findigs.com">pm-support@findigs.com</a> or try
      again.
    </p>
  );
};

/**
 * Route error view for the application
 * This should only be exported in error-boundary.base.tsx
 *
 * @returns JSX for the Error UI
 */
export const RouteErrorView = ({ error }: RouteErrorViewProps) => {
  return (
    <>
      <Links />
      <h1 className="text-d-md md:text-d-md mb-6">
        Error occurred ({error.status})
      </h1>
      <ErrorMessage status={error.status} />
      <Button as="a" href="/" variant="Tonal">
        Back to home
      </Button>
    </>
  );
};
